import React from 'react';
import { Star, ArrowRight, Award, Users, TrendingUp } from 'lucide-react';

export function SponsoredAd() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-blue-50 rounded-lg shadow-lg border border-blue-100 p-6 mb-8 transition-transform hover:scale-[1.01] duration-300">
      {/* Sponsored Badge */}
      <div className="absolute top-4 right-4 flex items-center gap-2 bg-blue-50 text-blue-600 px-3 py-1.5 rounded-full border border-blue-100">
        <Award className="w-4 h-4" />
        <span className="text-sm font-medium">Sponsored</span>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        {/* Left Content */}
        <div className="flex-1">
          {/* Rating */}
          <div className="flex items-center gap-1 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
              ))}
            </div>
            <span className="text-sm font-medium text-gray-600 ml-2">4.8 / 5.0</span>
          </div>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            ScrewHero: The Ultimate Platform for Tradespeople
          </h2>

          {/* Features */}
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            <div className="flex items-start gap-3">
              <Users className="w-5 h-5 text-blue-600 mt-1" />
              <div>
                <h3 className="font-medium text-gray-900">Growing Community</h3>
                <p className="text-sm text-gray-600">Join UK tradespeople</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <TrendingUp className="w-5 h-5 text-blue-600 mt-1" />
              <div>
                <h3 className="font-medium text-gray-900">Business Growth</h3>
                <p className="text-sm text-gray-600">Average 40% more leads</p>
              </div>
            </div>
          </div>

          {/* Special Offer */}
          <div className="inline-block bg-green-50 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            🎉 Special Launch Offer: 80% off your first 3 months!
          </div>
        </div>

        {/* Right Content - CTA */}
        <div className="flex flex-col items-start lg:items-center">
          <a
            href="https://screwhero.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Start Growing Today
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700" />
    </div>
  );
}